module.exports = __webpack_public_path__ + "img/start2.ad59df3.png";